<template>
  <v-layout
    row
    wrap>
    <v-flex
      :class="horizontal && hasVat ? 'xs6' : 'xs12'"
    >
      <money-input
        v-model="price"
        :label="$t(netLabel)"
        :disabled="netDisabled"
      />
    </v-flex>

    <v-flex
      :class="horizontal && hasVat ? 'xs6' : 'xs12'"
    >
      <money-input
        v-if="hasVat || netDisabled"
        v-model="grossPrice"
        :label="$t(grossLabel)"
        :disabled="grossDisabled"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import MoneyInput from '@/components/form/MoneyInput'
import Money from 'js-money'

export default {
  name: 'ProductPrice',

  components: {
    MoneyInput
  },

  props: {
    value: {
      type: Object,
      default: () => {
        return {
          price: null,
          gross_price: null
        }
      }
    },
    netDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    grossDisabled: {
      type: Boolean,
      required: true
    },
    netLabel: {
      type: String,
      default: 'Price'
    },
    grossLabel: {
      type: String,
      default: 'Gross Price'
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    vat: {
      type: Object,
      default: () => {
        return {
          code: null,
          value: 1
        }
      },
      required: false
    }
  },

  computed: {
    price: {
      set (value) {
        this.$emit('input', {
          price: value,
          gross_price: this.grossPrice
        })
      },
      get () {
        return this.value.price || null
      }
    },
    grossPrice: {
      set (value) {
        this.$emit('input', {
          price: this.price,
          gross_price: value
        })
      },
      get () {
        return this.value.gross_price || null
      }
    },
    hasVat () {
      if (!this.vat) {
        return false
      }

      return this.vat.code !== null
    }
  },

  watch: {
    price: function () {
      this.recalculateGross()
    },

    grossPrice: function () {
      this.recalculateNet()
    },

    vat: function () {
      if (this.grossDisabled) {
        this.recalculateGross()
      }

      if (this.netDisabled) {
        this.recalculateNet()
      }
    }
  },

  methods: {
    recalculateGross () {
      if (!this.hasVat && typeof this.price === 'object') {
        this.grossPrice = this.price
        return
      }

      if (this.price === null || !this.hasVat || this.netDisabled) {
        return
      }

      const sourcePrice = new Money(parseInt(this.price.amount), this.price.currency)

      const vat = this.vat.value / 100

      this.grossPrice = sourcePrice.add(sourcePrice.multiply(vat))
    },

    recalculateNet () {
      if (this.grossPrice === null || !this.hasVat || this.grossDisabled) {
        return
      }

      const sourcePrice = new Money(parseInt(this.grossPrice.amount), this.grossPrice.currency)

      const vat = this.vat.value / 100
      this.price = sourcePrice.subtract(sourcePrice.multiply(vat).divide(vat + 1))
    }
  }
}
</script>
